const setting = {
  state: {
    taskType: [
      { type: 0, name: "商务 - 拜访" },
      { type: 1, name: "商务 - 签约" },
      { type: 2, name: "电商 - 拼团" },
      { type: 3, name: "电商 - 团购" },
      { type: 4, name: "电商 - 秒杀" },
      { type: 5, name: "外卖 - 限时折扣" },
      { type: 6, name: "外卖 - 折扣" },
      { type: 7, name: "外卖 - 新人专享" },
      { type: 8, name: "外卖 - 店铺满减" },
      { type: 9, name: "外卖 - 店铺满赠" },
      { type: 10, name: "外卖 - 店铺减配送费" },
      { type: 11, name: "外卖 - 新客立减" },
      { type: 12, name: "推广 - 注册" },
      { type: 13, name: "推广 -  下载APP并注册" }
    ]
  },
  mutations: {},
  actions: {}
};

export default setting;
